import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../static/common/flow.png';

const _withScopeId = n => (_pushScopeId("data-v-213f6ea5"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "partner-box header-top"
};
const _hoisted_2 = {
  class: "partner-box-content"
};
const _hoisted_3 = {
  class: "content-1-box common-flex-direction-center"
};

const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"common-title-box wow fadeInUp\" data-v-213f6ea5><div class=\"text-1\" data-v-213f6ea5>5</div><div class=\"text-2\" data-v-213f6ea5>大优势</div><div class=\"text-3\" data-v-213f6ea5>为您保驾护航</div></div><div class=\"common-des-box wow fadeInUp\" data-v-213f6ea5>亿万级市场规模优秀市场开拓能力</div>", 2);

const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = ["data-wow-delay"];
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  class: "item-text"
};
const _hoisted_10 = {
  class: "content-2-box common-flex-direction-center"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-title-box wow fadeInUp"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text-1"
}, "6"), /*#__PURE__*/_createElementVNode("div", {
  class: "text-2"
}, "大盈利模式")], -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-des-box wow fadeInUp"
}, "6大盈利体系，快速回本", -1));

const _hoisted_13 = {
  class: "content"
};
const _hoisted_14 = ["data-wow-delay"];
const _hoisted_15 = ["src", "alt"];
const _hoisted_16 = {
  class: "item-text wow lightSpeedInLeft"
};
const _hoisted_17 = {
  class: "content-3-box common-flex-direction-center"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-title-box wow slideInDown"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text-1"
}, "10"), /*#__PURE__*/_createElementVNode("div", {
  class: "text-2"
}, "大政策扶持")], -1));

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-des-box wow zoomIn"
}, "校园合伙人的全方位扶持计划", -1));

const _hoisted_20 = {
  class: "content"
};
const _hoisted_21 = ["data-wow-delay"];
const _hoisted_22 = ["src", "alt"];
const _hoisted_23 = {
  class: "item-text"
};
const _hoisted_24 = {
  class: "content-4-box common-flex-direction-center"
};

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow rollIn"
}, "扶持条件", -1));

const _hoisted_26 = {
  class: "content"
};
const _hoisted_27 = ["data-wow-delay"];
const _hoisted_28 = ["src", "alt"];
const _hoisted_29 = {
  class: "item-name"
};
const _hoisted_30 = {
  class: "content-5-box common-flex-direction-center"
};

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow slideInDown"
}, "高校合伙人合作流程", -1));

const _hoisted_32 = {
  class: "content"
};
const _hoisted_33 = ["data-wow-delay"];
const _hoisted_34 = ["src", "alt"];
const _hoisted_35 = {
  class: "item-title"
};

const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "step-image-box wow slideInLeft"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_0
})], -1));

const _hoisted_37 = {
  class: "content"
};
const _hoisted_38 = ["data-wow-delay"];
const _hoisted_39 = {
  class: "item-des"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");

  const _component_ImageTop = _resolveComponent("ImageTop");

  const _component_Follow = _resolveComponent("Follow");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Header, {
    activeIndex: 1,
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_ImageTop), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.advantageList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow flipInY",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "item-image",
      src: item.image,
      alt: item.name
    }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1)], 8, _hoisted_7);
  }), 128))])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _hoisted_12, _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.profitModelList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow fadeInUp",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "item-image",
      src: item.image,
      alt: item.name
    }, null, 8, _hoisted_15), _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1)], 8, _hoisted_14);
  }), 128))])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _hoisted_19, _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.supportList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow zoomIn",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "item-image",
      src: item.image,
      alt: item.name
    }, null, 8, _hoisted_22), _createElementVNode("div", _hoisted_23, _toDisplayString(item.name), 1)], 8, _hoisted_21);
  }), 128))])]), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.conditionList, (scene, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow rollIn",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "item-image",
      src: scene.image,
      alt: scene.name
    }, null, 8, _hoisted_28), _createElementVNode("div", _hoisted_29, _toDisplayString(scene.name), 1)], 8, _hoisted_27);
  }), 128))])]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.flowList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow flipInY",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "item-image",
      src: item.image,
      alt: item.title
    }, null, 8, _hoisted_34), _createElementVNode("div", _hoisted_35, _toDisplayString(item.title), 1)], 8, _hoisted_33);
  }), 128))]), _hoisted_36, _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.flowList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow flipInY",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("div", _hoisted_39, _toDisplayString(item.des), 1)], 8, _hoisted_38);
  }), 128))])])]), _createVNode(_component_Follow), _createVNode(_component_Footer, {
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"])]);
}